// Dag/natt/NVG-modus for feltbruk. Setter data-mode på <html>; CSS-variabler
// og et kart-filter reagerer. NVG = rødtonet for nattbevart mørkesyn.
export type ThemeMode = 'natt' | 'dag' | 'nvg';
const ORDER: ThemeMode[] = ['natt', 'dag', 'nvg'];

let current: ThemeMode = 'natt';

export function applyMode(mode: ThemeMode): void {
  current = mode;
  document.documentElement.dataset.mode = mode;
}

export function cycleMode(): ThemeMode {
  const next = ORDER[(ORDER.indexOf(current) + 1) % ORDER.length];
  applyMode(next);
  return next;
}

export function modeLabel(): string {
  return current.toUpperCase();
}
